// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_hyX","content":"styles_content__19kgm"};